module.exports = __webpack_public_path__ + "static/img/image_article_030.9dbf710.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/article_img/image_article_030.png
// module id = Fog3
// module chunks = 0